import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
};
type payout = Array<{
  totalCount: number;
  list: Array<{
    _id: string;
    amount: number;
    status: number;
    freelancerId: {
      _id: string;
      firstName: string;
      lastName: string;
      image: string;
      email: string;
    };
    createdAt: string;
  }>;
}>;
export const payOutApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPayOut: builder.query<
      CommonResponseType & { data: payout },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ search, page, limit }) => ({
        url: `${END_POINTS.payout}?search=${search}&page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),
  }),
});
export const { useLazyGetPayOutQuery } = payOutApi;
